import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import Vuerify from 'vuerify'
import VuerifyDirective from 'v-vuerify-next'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // 简体中文
import Print from 'vue-print-nb'

import '../static/login.css'
import store from './auth/store'
import routes from './routes'
import { zhMessages } from './lang/zh.js'
import CryptoJS from 'crypto-js/core'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import Base64 from 'crypto-js/enc-base64'

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuerify, {
    icode: { test: /^\d{6}$/, message: '请输入6位数字' },
    mobile: { test: /\d{1,}/, message: 'Mobile must have 1 or more numbers' },
    realname: { test: /^[A-Za-z0-9][A-Za-z0-9\s]{2,18}[A-Za-z0-9]$/, message: '请输入正确姓名' },
    password: { test: /\S{6,20}/, message: '密码格式不对' },
    postcode: { test: /^\d{6}$/, message: '请输入6位数字' },
    height: { test: /^\d{2,}$/, message: 'Height must have 2 or more numbers' },
    weight: { test: /^\d{2,}$/, message: 'Weight must have 2 or more numbers' },
    email: { test: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Please enter a valid Email.' },
});
Vue.use(VuerifyDirective);
Vue.use(VueI18n);
Vue.use(Vuex);
// 导入打印使用的组件
Vue.use(Print);

const i18n = new VueI18n({
    locale: 'zh',
    messages: {
        'zh': Object.assign(zhMessages, zhLocale)
    },
});
Vue.use(ElementUI, {
    // i18n: (key, value) => i18n.t(key, value)
});

const router = new VueRouter({
    //mode:'history',
    routes
});

// 生成随机数（32字节数据的hex表示）
function generateNonce() {
  const array = new Uint8Array(32)
  // 使用浏览器提供的crypto API
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(array)
  } else {
    // 兼容性处理：如果浏览器不支持，使用Math.random()生成伪随机数
    for (let i = 0; i < 32; i++) {
      array[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('')
}

// 高级密钥混淆函数 - 使用多种加密技术还原原始密钥
function deobfuscateKey(obfuscatedKey) {
  // 移除可能的多余引号
  const cleanKey = obfuscatedKey.replace(/"/g, '')
  
  // 方法1：多层Base64解码
  try {
    let decoded = cleanKey
    // 尝试多层Base64解码（最多3层）
    for (let i = 0; i < 3; i++) {
      try {
        decoded = atob(decoded)
        // 检查是否已经是可读文本
        if (isReadableText(decoded)) {
          return decoded
        }
      } catch (e) {
        break
      }
    }
  } catch (e) {
    console.warn('多层Base64解码失败，尝试其他方法')
  }
  
  // 方法2：AES加密解密（使用固定密钥）
  try {
    const aesKey = 'medtrum_secure_key_2024'
    const decrypted = decryptAES(cleanKey, aesKey)
    if (decrypted && decrypted.length > 0) {
      return decrypted
    }
  } catch (e) {
    console.warn('AES解密失败，尝试其他方法')
  }
  
  // 方法3：异或加密解密
  try {
    const xorKey = 'medtrum_xor_key'
    const decrypted = decryptXOR(cleanKey, xorKey)
    if (decrypted && decrypted.length > 0) {
      return decrypted
    }
  } catch (e) {
    console.warn('异或解密失败，尝试其他方法')
  }
  
  // 方法4：凯撒密码解密
  try {
    const decrypted = decryptCaesar(cleanKey, 5)
    if (decrypted && decrypted.length > 0) {
      return decrypted
    }
  } catch (e) {
    console.warn('凯撒密码解密失败，尝试其他方法')
  }
  
  // 方法5：字符反转 + 移位
  try {
    const decrypted = decryptComplex(cleanKey)
    if (decrypted && decrypted.length > 0) {
      return decrypted
    }
  } catch (e) {
    console.warn('复杂解密失败，尝试其他方法')
  }
  
  // 如果以上方法都失败，返回原始密钥（作为最后备用）
  console.warn('所有高级混淆解密方法失败，使用原始密钥')
  return cleanKey
}

// 检查是否为可读文本
function isReadableText(str) {
  // 检查字符串是否包含字母、数字和常见符号
  const readableRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]*$/
  return readableRegex.test(str) && str.length >= 10
}

// AES加密解密函数（简化版，使用CryptoJS）
function decryptAES(encryptedText, key) {
  try {
    // 简化的AES解密逻辑
    // 在实际项目中，您可以使用CryptoJS.AES.decrypt
    const words = CryptoJS.enc.Base64.parse(encryptedText)
    const keyBytes = CryptoJS.enc.Utf8.parse(key)
    const decrypted = CryptoJS.AES.decrypt({ciphertext: words}, keyBytes, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (e) {
    throw new Error('AES解密失败')
  }
}

// 异或加密解密
function decryptXOR(encryptedText, key) {
  let result = ''
  for (let i = 0; i < encryptedText.length; i++) {
    const charCode = encryptedText.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    result += String.fromCharCode(charCode)
  }
  return result
}

// 凯撒密码解密
function decryptCaesar(encryptedText, shift) {
  let result = ''
  for (let i = 0; i < encryptedText.length; i++) {
    let charCode = encryptedText.charCodeAt(i)
    if (charCode >= 65 && charCode <= 90) { // 大写字母
      charCode = ((charCode - 65 - shift + 26) % 26) + 65
    } else if (charCode >= 97 && charCode <= 122) { // 小写字母
      charCode = ((charCode - 97 - shift + 26) % 26) + 97
    }
    result += String.fromCharCode(charCode)
  }
  return result
}

// 复杂解密：字符反转 + 移位 + 替换
function decryptComplex(encryptedText) {
  // 步骤1：字符反转
  let step1 = encryptedText.split('').reverse().join('')
  
  // 步骤2：ASCII码移位（每个字符减3）
  let step2 = ''
  for (let i = 0; i < step1.length; i++) {
    step2 += String.fromCharCode(step1.charCodeAt(i) - 3)
  }
  
  // 步骤3：字符替换
  const replaceMap = {
    'a': 'w', 'b': 'e', 'c': 'b', 'd': '6', 'e': '3',
    'f': 'L', 'g': 'P', 'h': 'G', 'i': 'c', 'j': 'K',
    'k': 'U', 'l': 'L', 'm': 'i', 'n': 'n', 'o': 'v',
    'p': 'N', 'q': 'J', 'r': 'R', 's': 'C', 't': 'm',
    'u': 'b', 'v': 'Z', 'w': 'z', 'x': '8', 'y': 'y',
    'z': '4', '0': 'n', '1': 'M', '2': 'e', '3': 'd',
    '4': 't', '5': 'r', '6': 'u', '7': 'm', '8': '2',
    '9': '0', 'A': '2', 'B': '4'
  }
  
  let step3 = ''
  for (let i = 0; i < step2.length; i++) {
    const char = step2[i]
    step3 += replaceMap[char] || char
  }
  
  return step3
}

// 高级混淆生成函数（用于生成混淆后的密钥配置）
function obfuscateKeyAdvanced(originalKey) {
  // 步骤1：字符替换
  const reverseMap = {
    'w': 'a', 'e': 'b', 'b': 'c', '6': 'd', '3': 'e',
    'L': 'f', 'P': 'g', 'G': 'h', 'c': 'i', 'K': 'j',
    'U': 'k', 'L': 'l', 'i': 'm', 'n': 'n', 'v': 'o',
    'N': 'p', 'J': 'q', 'R': 'r', 'C': 's', 'm': 't',
    'b': 'u', 'Z': 'v', 'z': 'w', '8': 'x', 'y': 'y',
    '4': 'z', 'n': '0', 'M': '1', 'e': '2', 'd': '3',
    't': '4', 'r': '5', 'u': '6', 'm': '7', '2': '8',
    '0': '9', '2': 'A', '4': 'B'
  }
  
  let step1 = ''
  for (let i = 0; i < originalKey.length; i++) {
    const char = originalKey[i]
    step1 += reverseMap[char] || char
  }
  
  // 步骤2：ASCII码移位（每个字符加3）
  let step2 = ''
  for (let i = 0; i < step1.length; i++) {
    step2 += String.fromCharCode(step1.charCodeAt(i) + 3)
  }
  
  // 步骤3：字符反转
  const step3 = step2.split('').reverse().join('')
  
  // 步骤4：多层Base64编码（2层）
  const step4 = btoa(btoa(step3))
  
  return step4
}

// 生成HMAC-SHA256签名
function generateSignature(config, timestamp, nonce, deviceId, secretKey) {
    
  // 构建完整URL - 根据环境使用不同的baseURL
  // 开发环境使用本地地址，生产环境使用线上地址
  const isDevelopment = process.env.NODE_ENV === 'development'
  const baseURL = isDevelopment ? 'https://crt.medtrum.cn' : window.location.origin
  const url = config.url || ''
  const fullUrl = baseURL + url
  
  // 处理URL：替换http://为https://，然后获取最后128位
  let processedUrl = fullUrl
  // 如果请求方式是get，需要把请求参数拼接到url后面
  if(config.method === 'get' && config.body){
    // 将参数对象转换为URL查询字符串格式
    const queryString = new URLSearchParams(config.body).toString()
    processedUrl += '?' + queryString
  }
 const urlLast128 = processedUrl.slice(-128).replace("http://", "https://")  // 获取最后128个字符
  // 获取请求参数并处理
  let requestParams = ''
  
  if (config.body) {
    requestParams = JSON.stringify(config.body)
  } else if (config.data) {
    requestParams = JSON.stringify(config.data)
  }
  if(config.method === 'get'){
    requestParams = ''
  }
  // 处理请求参数：去除空格并截取前64个字符
  
  // 使用UTF-8字节长度进行截取，确保与Python一致
  const dataPart = (() => {
    // 去除空格
    const cleanStr = requestParams.replace(/\s+/g, '')
    
    // 使用UTF-8编码获取字节数组
    const encoder = new TextEncoder()
    const utf8Bytes = encoder.encode(cleanStr)
    
    // 截取前64个字节
    const slicedBytes = utf8Bytes.slice(0, 64)
    
    // 将字节数组转换回字符串
    const decoder = new TextDecoder('utf-8')
    return decoder.decode(slicedBytes)
  })()
  // 构建消息：地址最后128位 + 处理后的请求参数 + 随机数 + 设备ID + 时间戳（逗号分隔）
  
  const message = `Med${urlLast128}${dataPart}${nonce}${deviceId}${timestamp}`
  
 console.log('message',message)
  // 使用HMAC-SHA256算法进行加密，返回Base64格式的哈希值
  return HmacSHA256(message, secretKey).toString(Base64)
}

// 获取设备ID
function getDeviceId() {
  // 优先使用localStorage中的设备ID，如果没有则生成一个新的
  let deviceId = localStorage.getItem('device_id')
  if (!deviceId) {
    deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
    localStorage.setItem('device_id', deviceId)
  }
  return deviceId
}
Vue.prototype.pushRequest = function(request) {
    this.$store.commit('updateRequest', request);
};
// 请求拦截器
Vue.http.interceptors.push((request, next) => {
    if (request.method === 'GET') {
        if (request.url.indexOf('?') > 0) {
            request.url += '&_=' + new Date().getTime();
        } else {
            request.url += '?_=' + new Date().getTime();
        }
    }
    let MachID =localStorage.getItem('MachineCodeMZ')
    request.headers.set('Token', 'C0NNqtiOd2BWElrR8W4l8c2t5O1NaX0D2c7cgGfFAyYykYTtgh6KUJTwA8WBSBkd')
    request.headers.set('AppTag', 'n=ccrt;v=1.0.6(6)')
    const timestamp = Math.floor(Date.now() / 1000).toString()
    const nonce = generateNonce()
    const deviceId = getDeviceId()
    // 这里需要设置你的密钥，可以从环境变量或配置文件中获取
    
    // 使用固定的HMAC密钥（在实际生产环境中应该从安全配置中获取）
    const secretKey = deobfuscateKey(process.env.VUE_APP_HMAC_KEY)
    const signature = generateSignature(request, timestamp, nonce, deviceId, secretKey)
     request.headers.set('X-Timestamp', timestamp)
     request.headers.set('X-Nonce', nonce)
     request.headers.set('X-Signature', signature)
     request.headers.set('X-DeviceId', deviceId)

    if(MachID){
        request.headers.set('MachID', MachID)
    }else{
        request.headers.set('MachID', '')
    }

    next((response) => {
        const ERROR = response.data.error
        i18n.locale = store.getters.getLang
        // 对于error不是0的返回值进行处理
        if(ERROR){
          switch(ERROR){
            case 1061:
              router.push('/login')
              sessionStorage.setItem('1061Flag','true')
              break
          }
        }
        return response
    });
});
let vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js